module.exports = {
  bindings: {
    authenticatedPatient: '<',
    currentPatient: '<',
    group: '<',
  },
  templateUrl: 'main/components/patient-selector/patient-selector.html',
  controller: class PatientSelectorController {

    static $inject = [
      '$scope',
      '$state',
    ];

    patients = [];

    constructor($scope, $state) {
      this.$scope = $scope;
      this.$state = $state;
    }

    $onInit() {
      this.isOpen = false;

      this.updatePatients();

      this.bindStateChange();
      this.bindViewportClick();
    }

    $onChanges() {
      this.updatePatients();
    }

    bindStateChange() {
      this.$scope.$root.$on('$stateChangeSuccess', () => {
        this.isOpen = false;
      });
    }

    bindViewportClick() {
      this.$scope.$on('viewport:clicked', (event, args) => {
        if (!this.authenticatedPatient || !this.isOpen) {
          return;
        }

        const target = angular.element(args.jsEvent.target);
        if (target.parents('.dropdown').length <= 0 && !target.is('.dropdown')) {
          this.toggleDropdown();
        }
      });
    }

    toggleDropdown() {
      if (this.hasChildren) {
        this.isOpen = !this.isOpen;
      }
    }

    selectPatient(id) {
      if (this.currentPatient.id !== id) {
        this.$state.go('patients.id.home', { patientId: id });
      } else {
        this.$state.go('patients.id.home', { patientId: this.currentPatient.id });
      }

      this.toggleDropdown();
    }

    redirectToHomePage() {
      this.$state.go('patients.id.home', { patientId: this.currentPatient.id });
    }

    updatePatients() {
      if (!this.authenticatedPatient) {
        this.patients = [];
        return;
      }

      // Update patients list (all patients, with current patient first in the array)
      const allPatients = [this.authenticatedPatient].concat(this.authenticatedPatient.children);
      this.patients = [this.currentPatient].concat(_.sortBy(_.reject(allPatients, p => p.id === this.currentPatient.id), o => o.firstName + o.lastName));
    }

    get hasChildren() {
      return this.patients.length > 1;
    }
  },
};



// WEBPACK FOOTER //
// ./main/components/patient-selector/patient-selector.js